// extracted by mini-css-extract-plugin
export default {"TipBox":"TipBox_TipBox","TipBoxCopy":"TipBox_TipBoxCopy","TipBoxIcon":"TipBox_TipBoxIcon"};